var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5201 2.91016C9.21009 2.91016 6.52009 5.60016 6.52009 8.91016V11.8002C6.52009 12.4102 6.26009 13.3402 5.95009 13.8602L4.80009 15.7702C4.09009 16.9502 4.58009 18.2602 5.88009 18.7002C10.1901 20.1402 14.8401 20.1402 19.1501 18.7002C20.3601 18.3002 20.8901 16.8702 20.2301 15.7702L19.0801 13.8602C18.7801 13.3402 18.5201 12.4102 18.5201 11.8002V8.91016C18.5201 5.61016 15.8201 2.91016 12.5201 2.91016Z",
    stroke: "#8D98AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3699 3.20043C14.0599 3.11043 13.7399 3.04043 13.4099 3.00043C12.4499 2.88043 11.5299 2.95043 10.6699 3.20043C10.9599 2.46043 11.6799 1.94043 12.5199 1.94043C13.3599 1.94043 14.0799 2.46043 14.3699 3.20043Z",
    stroke: "#8D98AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.52 19.0596C15.52 20.7096 14.17 22.0596 12.52 22.0596C11.7 22.0596 10.94 21.7196 10.4 21.1796C9.86002 20.6396 9.52002 19.8796 9.52002 19.0596",
    stroke: "#8D98AE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.181465c2a1cb1ad4e855cd82c9ad296c.svg";
export { ForwardRef as ReactComponent };